import { render, staticRenderFns } from "./newnemberlinechart.component.vue?vue&type=template&id=48edbae3&scoped=true"
import script from "./newnemberlinechart.component.vue?vue&type=script&lang=js"
export * from "./newnemberlinechart.component.vue?vue&type=script&lang=js"
import style0 from "./newnemberlinechart.component.vue?vue&type=style&index=0&id=48edbae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edbae3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
